<template>
  <div>
    <h1 class="page-header">
      {{ $t('addministration.customer_feature.customer_profile') }}
    </h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-6">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'customer-profile-create' })"
            >
              {{ $t('addministration.customer_feature.add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-6 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('addministration.customer_feature.search')"
              style="width: 300px;"
              class="kh-font"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template slot-scope="{ record }">
          <td>{{ record.customer_name }}</td>
          <td>{{ record.gender }}</td>
          <td>
            {{ record.contact_no1 }}
            {{ record.contact_no2 ? ' / ' + record.contact_no2 : '' }}
          </td>
          <td>
            {{ record.customer_type ? record.customer_type.cus_type : '' }}
          </td>
          <td>
            {{ record.service_type ? record.service_type.service_name_en : '' }}
          </td>
          <td>
            {{ record.customer_zone ? record.customer_zone.cus_zone_name : '' }}
          </td>
          <td class="text-center">
            <span class="text-success" v-if="record.is_default"
              ><i class="fa fa-check"></i
            ></span>
          </td>
          <td class="text-center">
            <router-link
              :to="{
                name: 'customer-profile-edit',
                params: { id: record.customer_id }
              }"
              v-tooltip="$t('addministration.customer_feature.edit')"
              class="mr-3"
            >
              <i class="fas fa-edit"></i>
            </router-link>

            <a
              href="#"
              v-tooltip="$t('addministration.customer_feature.delete')"
              class="text-danger"
              @click="destroy(record.customer_id)"
            >
              <i class="fas fa-trash"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          :query="{ search }"
          @navigate="fetchData"
        >
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'customer-profile',
  data() {
    return {
      loading: false,
      columns: [
        {
          name: this.$t('addministration.customer_feature.name'),
          style: 'width: 15%;'
        },
        {
          name: this.$t('addministration.customer_feature.gender'),
          style: 'width: 7%;'
        },
        {
          name: this.$t('addministration.customer_feature.contact_no'),
          style: 'width: 18%;'
        },
        {
          name: this.$t('addministration.customer_feature.customer_type'),
          style: 'width: 15%;'
        },
        {
          name: this.$t('addministration.customer_feature.service_type'),
          style: 'width: 15%;'
        },
        { name: this.$t('addministration.customer_feature.customer_zone') },
        {
          name: this.$t('addministration.customer_feature.is_default'),
          style: 'text-align:center; width: 10%;'
        },
        {
          name: this.$t('addministration.customer_feature.action'),
          style: 'text-align:center; width: 1px;'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('customerProfile', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.customerProfile.search
      },
      set(newValue) {
        this.$store.commit('customerProfile/SET_SEARCH', newValue)
        this.$store.commit('customerProfile/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('customerProfile/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },

    async destroy(customer_id) {
      if (
        await this.$confirmModal.danger(
          this.$t('addministration.customer_feature.are_you_sure_to_delete')
        )
      ) {
        this.$store
          .dispatch('customerProfile/destroy', customer_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'customer-profile-create') {
      this.$store.commit('customerProfile/RESET_STATE')
      this.$store.commit('customerProfile/SET_CUSTOMER_ZONES')
    }
    next()
  }
}
</script>
